<template>
  <md-toolbar class="md-transparent" md-elevation="0">
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <!-- <v-card-title style="font-weight: 900">{{ $route.name }}</v-card-title> -->
      </div>
      <div class="md-toolbar-section-end">
        <!-- it was working before for dark/bright mode -->
        <!-- <v-switch v-model="themeAugmentable" label="Dark-Mode"></v-switch> -->

        <v-menu
          rounded="lg"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          down
          max-width="200"
        >
          <template v-slot:activator="{ on }">
            <div style="display: flex; justify-content: center" v-on="on">
              <p class="mt-3 mr-2" style="color: #419cff; font-size: 13px">
                beta-1.19
              </p>
              <v-btn icon>
                <md-icon
                  v-if="augmentableTheme"
                  class="md-size-2x"
                  md-src="/static/assets/svg/white/Manager.svg"
                >
                </md-icon>
                <md-icon
                  v-if="!augmentableTheme"
                  class="md-size-2x"
                  md-src="/static/assets/svg/black/Manager.svg"
                >
                </md-icon>
              </v-btn>
            </div>
          </template>
          <v-card
            class="ma-0 pa-0"
            width="200"
            height="225"
            rounded="lg"
            :style="{ background: $vuetify.theme.themes[theme].background }"
            ><div class="pl-7 pr-7 pt-4 ma-0">
              <p class="display-22"><strong>Profile Settings</strong></p>

              <div class="ma-0 pa-0" style="display: flex">
                <div class="ma-0 pa-0">
                  <v-btn
                    class="ma-0 pa-0 ml-n2 mt-n1"
                    icon
                    @click="userProfile()"
                  >
                    <v-icon>mdi-account-outline</v-icon>
                  </v-btn>
                </div>
                <div class="ma-0 pa-0 mt-1">
                  <p
                    class="caption-11"
                    style="cursor: pointer"
                    @click="userProfile()"
                  >
                    User Profile
                  </p>
                </div>
              </div>
              <v-divider
                class="pl-5 pr-5 mt-n3"
                style="border-color: #d3d3d3"
              ></v-divider>
              <div class="ma-0 pa-0" style="display: flex">
                <div class="ma-0 pa-0">
                  <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                    <v-icon>mdi-bell-alert-outline</v-icon>
                  </v-btn>
                </div>
                <div class="ma-0 pa-0 mt-1">
                  <p class="caption-11" style="cursor: pointer">
                    Notifications
                  </p>
                </div>
              </div>

              <v-divider
                class="pl-5 pr-5 mt-n3"
                style="border-color: #d3d3d3"
              ></v-divider>
              <div class="ma-0 pa-0" style="display: flex">
                <div class="ma-0 pa-0">
                  <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                    <v-icon>mdi-upload</v-icon>
                  </v-btn>
                </div>
                <div class="ma-0 pa-0 mt-1">
                  <p class="caption-11" style="cursor: pointer">
                    Upgrade License
                  </p>
                </div>
              </div>
              <v-divider
                class="pl-5 pr-5 mt-n3"
                style="border-color: #d3d3d3"
              ></v-divider>
              <div class="ma-0 pa-0" style="display: flex">
                <div class="ma-0 pa-0">
                  <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
                <div class="ma-0 pa-0 mt-1">
                  <p class="caption-11" style="cursor: pointer">Help</p>
                </div>
              </div>
              <v-divider
                class="pl-5 pr-5 mt-n3"
                style="border-color: #d3d3d3"
              ></v-divider>
              <div class="ma-0 pa-0" style="display: flex">
                <div class="ma-0 pa-0">
                  <v-btn
                    class="ma-0 pa-0 ml-n2 mt-n1"
                    icon
                    @click="userLogout()"
                  >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </div>
                <div class="ma-0 pa-0 mt-1">
                  <p
                    class="caption-11"
                    style="cursor: pointer"
                    @click="userLogout()"
                  >
                    Log Out
                  </p>
                </div>
              </div>
              <v-divider
                class="pl-5 pr-5 mt-n3"
                style="border-color: #d3d3d3"
              ></v-divider>
            </div>
          </v-card>
        </v-menu>

        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <!--
        <div class="md-collapse">
          <div class="md-autocomplete">
            <md-autocomplete class="search" v-model="selectedEmployee" :md-options="employees">
              <label>Search...</label>
            </md-autocomplete>
          </div>
          <md-list>
            <md-list-item href="/dashboard">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

             <md-list-item href="#/notifications" class="dropdown">
              <drop-down>
                <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="material-icons">notifications</i>
                  <span class="notification">5</span>
                  <p class="hidden-lg hidden-md">Notifications</p>
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li><a href="#">Mike John responded to your email</a></li>
                  <li><a href="#">You have 5 new tasks</a></li>
                  <li><a href="#">You're now friend with Andrew</a></li>
                  <li><a href="#">Another Notification</a></li>
                  <li><a href="#">Another One</a></li>
                </ul>
              </drop-down>
            </md-list-item>

            <li class="md-list-item">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span class="notification">5</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <a>Weltfern responded to your email</a>
                      </li>
                      <li>
                        <a>You have 5 new tasks</a>
                      </li>
                      <li>
                        <a>You're now friend with Augmentable</a>
                      </li>
                      <li>
                        <a>Another Notification</a>
                      </li>
                      <li>
                        <a>Another One</a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item href="/user">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
        -->
      </div>
    </div>
  </md-toolbar>
</template>

<script>
//import "../../assets/scss/material-dashboard.scss";

import store from "../../store";
import { mapState } from "vuex";

export default {
  data() {
    return {
      selectedEmployee: null,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],

      //themeAugmentable: false,
    };
  },
  watch: {
    /*
    themeAugmentable(newValue) {
      if (newValue === true) {
        this.$store.commit("setAugmentableTheme", true);
        this.$vuetify.theme.dark = true;
      } else {
        this.$store.commit("setAugmentableTheme", false);
        this.$vuetify.theme.dark = false;
      }
    },
    */
  },
  computed: {
    ...mapState(["augmentableTheme"]),
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  mounted() {
    //this.themeAugmentable = store.state.augmentableTheme;
    console.log("hhhhhhhhh");
    console.log(this.augmentableTheme);
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },

    changeTheme() {
      if (this.themeAugmentable === true) {
        this.themeAugmentable = false;
        this.$store.commit("setAugmentableTheme", false);
        this.$vuetify.theme.dark = false;
      } else if (this.themeAugmentable === false) {
        this.themeAugmentable = true;
        this.$store.commit("setAugmentableTheme", true);
        this.$vuetify.theme.dark = true;
      }
    },
    userProfile() {
      if (store.state.userType === "basic") {
        this.$router.push({ path: "/assets" });
      } else {
        this.$router.push({ path: "/user_profile" });
      }
    },
    userLogout() {
      this.$store.commit("setAuthentication", false);
      //expiring cookie and delete
      document.cookie =
        "augmentableUserToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.$router.push({ name: "account" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/material-dashboard.scss";
</style>
